import React from 'react'
import AboutMe from './AboutMe'

export default function PageContactMe() {
    return (
        <>
            <div className="section">
                <div className="container">
                    <AboutMe />
                </div>
            </div>
        </>
    )
}
